import { defineAsyncComponent, type Component } from 'vue'

const formModules = import.meta.glob<{ default: Component }>('./*/*.vue')

const formAliases: Record<string, string> = {
  gad7: 'gad',
  phq9: 'phq',
  pcl5: 'pcl',
  ocir: 'oci',
  'oci-r': 'oci',
  hit6: 'hit',
}

export function normalizeFormKey(value?: string | null) {
  if (!value) {
    return ''
  }

  const normalized = value
    .toLowerCase()
    .trim()
    .replace(/[\s_-]+/g, '')

  return formAliases[normalized] ?? normalized
}

function toComponentName(formKey: string) {
  return formKey ? `${formKey.charAt(0).toUpperCase()}${formKey.slice(1)}` : ''
}

export function resolveFormComponent(value?: string | null): Component | null {
  const formKey = normalizeFormKey(value)

  if (!formKey) {
    return null
  }

  const path = `./${formKey}/${toComponentName(formKey)}.vue`
  const loader = formModules[path]

  if (!loader) {
    return null
  }

  return defineAsyncComponent(loader)
}
